import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import type { RootState } from 'common/store/types';

type TClient = {
  name: string | null
  logo: string | null
  product: {
    product_id: number,
    product_category_id: number,
  }[] | null
}

const initialState = {
  name: null,
  logo: null,
  product: null,
}

const clientSlice = createSlice({
  name: 'client',
  initialState: initialState as TClient,
  reducers: {
    setClient: (
      state,
      { payload: { name, logo, product } }: PayloadAction<TClient>,
    ) => {
      state.name = name;
      state.logo = logo;
      state.product = product;
    },
    clearClient: (state) => {
      state.name = clientSlice.getInitialState().name;
      state.logo = clientSlice.getInitialState().logo;
      state.product = clientSlice.getInitialState().product;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state.name = clientSlice.getInitialState().name;
      state.logo = clientSlice.getInitialState().logo;
      state.product = clientSlice.getInitialState().product;
    });
  },
});

export const { setClient, clearClient } = clientSlice.actions;

export default clientSlice.reducer;

export const selectCurrentClient = (state: RootState) => state.auth;
